import * as E from "~/renderer/web-components/element";
import * as S from "~/styles/sfml.css";
import * as C from "~/constants";

export class WayfinderCategory extends E.SFMLElement {
  private _label: HTMLElement;
  private _badge: HTMLElement;

  public get label() {
    return this._label;
  }

  public get badge() {
    return this._badge;
  }

  public get anchorId() {
    const rawAnchorId = this.getAttribute("sfml-anchor-id");

    if (!rawAnchorId) return null;

    return parseInt(rawAnchorId);
  }

  constructor() {
    super();

    this._label = document.createElement("div");
    this._label.className = S.label;
    this._badge = document.createElement("div");
    this._badge.className = S.badge;

    this.appendChild(this._label);
    this.appendChild(this._badge);
  }

  private onClickHandler = (e: Event) => {
    e.preventDefault();
    e.stopPropagation();

    const anchorId = this.getAttribute("anchor-id");
    if (!anchorId) return;

    const event = new CustomEvent(C.ANCHOR_REQUEST_EVENT, {
      bubbles: true,
      detail: { anchorId },
    });
    this.dispatchEvent(event);
  };

  connectedCallback() {
    this.addEventListener("click", this.onClickHandler);
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.onClickHandler);
  }
}
customElements.define("sfml-wayfinder-category", WayfinderCategory);



// WEBPACK FOOTER //
// webpack://SFMLWeb/src/renderer/web-components/wayfinder/category.ts